<script lang="ts">
    // svelte-ignore unused-export-let
    export let params: any = {};
</script>

<h1>404: Page not found</h1>